module.exports = __webpack_public_path__ + "static/media/gov-logo.ac30b18b.svg";